import React from 'react';
import { createRoot } from 'react-dom/client';
import { FluentProvider, webLightTheme } from '@fluentui/react-components';
import App from './App';
import LoginPage from "./Pages/LoginPage";
import {BrowserRouter, Route, Routes} from "react-router-dom";
import {AuthProvider} from "./Services/AuthContext";
import {CssBaseline, ThemeProvider} from "@mui/material";
import {createTheme} from "@mui/material/styles";
import RegisterPage from "./Pages/RegisterPage";
import ResetPage from "./Pages/ResetPage";
import NewPasswordPage from "./Pages/NewPasswordPage";
import LandingPage from "./Pages/LandingPage";
import Organizer from "./Pages/Organizer";
import Season from "./Pages/Season";
import OrganizerCamp from "./Pages/OrganizerCamp";
import UserOrganized from "./Pages/UserOrganized";
import UserRegistrations from "./Pages/UserRegistrations";
import Children from "./Pages/Children";
import Camp from "./Pages/Camp";
import CampRegistrations from "./Pages/CampRegistrations";
import SeasonCamp from "./Pages/SeasonCamp";
import PrivacyPolicy from "./Pages/PrivacyPolicy";
import Statute from "./Pages/Statute";
import Contact from "./Pages/Contact";
import ForOrganizations from "./Pages/ForOrganizations";
import FAQ from "./Pages/FAQ";
import Profile from "./Pages/Profile";
import SeasonPriorities from "./Pages/SeasonPriorities";
import OrganizerSettings from "./Pages/OrganizerSettings";
import ChildrenAdvanced from "./Pages/ChildrenAdvanced";
import ChildrenDetails from "./Pages/AdvancedRegistration/ChildrenDetails";
import ChildrenOverview from "./Pages/AdvancedRegistration/ChildrenOverview";
import ChildrenAllowed from "./Pages/AdvancedRegistration/ChildrenAllowed";
import ChildrenAgreement from "./Pages/AdvancedRegistration/ChildrenAgreement";
import ChildrenDocument from "./Pages/AdvancedRegistration/ChildrenDocument";

let theme = createTheme({
    // Theme customization goes here as usual, including tonalOffset and/or
    // contrastThreshold as the augmentColor() function relies on these
});

theme = createTheme(theme, {
    // Custom colors created with augmentColor go here
    palette: {
        salmon: theme.palette.augmentColor({
            color: {
                main: '#FF5733',
            },
            name: 'salmon',
        }),
        anthracite: theme.palette.augmentColor({
            color: {
                main: 'rgb(28, 37, 46)',
            },
            name: 'anthracite'
        }),
        gray: theme.palette.augmentColor({
            color: {
                main: 'rgb(123, 128, 154)',
            },
            name: 'gray'
        })
    },
});

const root = createRoot(document.getElementById('root'));

root.render(
    <FluentProvider theme={webLightTheme}>
        <BrowserRouter>
            <AuthProvider>
                <CssBaseline />
                <ThemeProvider theme={theme}>
                    <Routes>
                        <Route path="/login" element={<LoginPage />} />
                        <Route path="/logout" element={<LoginPage />} />
                        <Route path="/index.html" element={<LoginPage />} />
                        <Route path="/login/confirmed" element={<LoginPage />} />
                        <Route path="/login/expired" element={<LoginPage />} />
                        <Route path="/login/reseted" element={<LoginPage />} />
                        <Route path="/register" element={<RegisterPage />} />
                        <Route path="/reset" element={<ResetPage />} />
                        <Route path="/new_password/:token" element={<NewPasswordPage />} />
                        <Route path="/" element={<App />}>
                            <Route index element={<LandingPage />} />
                            <Route path='/q/:query' element={<LandingPage />} />
                            <Route path='/kontakt' element={<Contact />} />
                            <Route path='/profile' element={<Profile />} />
                            <Route path='/faq' element={<FAQ />} />
                            <Route path='/dla-organizatorow' element={<ForOrganizations />} />
                            <Route path='/polityka-prywatnosci' element={<PrivacyPolicy />} />
                            <Route path='/regulamin' element={<Statute />} />
                            <Route path="/organizer" element={<Organizer />} />
                            <Route path="/organizer/:id/camps" element={<OrganizerCamp />} />
                            <Route path="/organizer/:id/settings" element={<OrganizerSettings />} />
                            <Route path="/season" element={<Season />} />
                            <Route path="/season/:id" element={<SeasonCamp />} />
                            <Route path="/season/:id/advanced" element={<ChildrenAdvanced />}>
                                <Route index element={<ChildrenOverview />} />
                                <Route path='overview' element={<ChildrenOverview />} />
                                <Route path='details' element={<ChildrenDetails />} />
                                <Route path='allowed' element={<ChildrenAllowed />} />
                                <Route path='agreement' element={<ChildrenAgreement />} />
                                <Route path='document' element={<ChildrenDocument />} />
                            </Route>
                            <Route path="/season/:id/priority" element={<SeasonPriorities />} />
                            <Route path="/children" element={<Children />} />
                            <Route path="/camps" element={<UserOrganized />} />
                            <Route path="/registrations" element={<UserRegistrations />} />
                            <Route path="/registrations/:id" element={<UserRegistrations />} />
                            <Route path="/camp/:id" element={<Camp />} />
                            <Route path="/camp/:id/list" element={<CampRegistrations />} />
                            <Route path='/:query' element={<LandingPage />} />
                        </Route>
                    </Routes>
                </ThemeProvider>
            </AuthProvider>
        </BrowserRouter>
    </FluentProvider>
);